<template>
  <!-- End Sessin With Diff Admin Modal  -->
  <b-modal
    id="endSessionWithDiffAdminModal"
    class="popover-modal"
    hide-header
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    ref="endSessionWithDiffAdminModal"
  >
    <div class="content-cont">
      <div class="headerwith-title d-flex">
        <p class="headerr-title">Session Ended</p>
      </div>
      <div class="hint-modal">
        The emergency session
        <span class="sessionName">“{{ sessionName }}”</span> has been ended by
        admin <b>({{ diffAdminEndSessionName }})</b>
        <span v-if="$route.name != 'EmergencySeesionListData'"
          >. To view the session results, click <b>“View”</b></span
        >
      </div>
    </div>
    <div class="inside-emergency-line"></div>
    <div class="actions-btn d-flex align-items-center justify-content-center">
      <button
        class="single-okay"
        v-if="$route.name == 'EmergencySeesionListData'"
        type="button"
        @click="goToSessionEnded()"
      >
        Okay
      </button>
      <template v-else>
        <div class="d-flex align-items-center justify-content-center">
          <button type="button" class="single-join" @click="goToSessionEnded()">
            View
          </button>
          <button
            type="button"
            class="single-dismiss"
            @click="$bvModal.hide('endSessionWithDiffAdminModal')"
          >
            Dismiss
          </button>
        </div>
      </template>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "endSessionWithDiffAdminModal",
  props: ["diffAdminEndSessionName", "sessionName", "sessionId"],
  methods: {
    goToSessionEnded() {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";
      window.location.href = `${process.env.VUE_APP_DOMAIN}/emergency-sessions/${this.sessionName}/${this.sessionId}`;
    },
  },
};
</script>

<style lang="scss">
div#endSessionWithDiffAdminModal {
  padding: right 0px !important;
  // background:  #E5E5E5;
  div#endSessionWithDiffAdminModal___BV_modal_content_ {
    width: 500px;

    margin-top: 250px;
    background: #ffffff;
    box-shadow: 0px 1px 40px 3px rgb(0 0 0 / 5%);
    border-radius: 26px;
  }
  .modal-content .modal-body {
    padding: 0px !important;
    padding-bottom: 0px !important;
    border-radius: 26px !important;
    p.headerr-title {
      font-weight: 700;
      font-size: 17px;
      line-height: 20px;
      text-align: center;
      color: #000000;
      margin: 40px auto;
    }
    .actions-btn {
      width: 420px;
      margin: 0px auto 20px auto;
    }
    button.single-okay {
      background: #103f5e;
      width: 112px;
      height: 32px;
      border: none;
      color: #ffffff;
      border-radius: 16px;
      margin: auto;
      font-weight: 400;
      display: flex;
      align-items: 16px;
      font-size: 16px;
      justify-content: center;
      align-items: center;
      line-height: 19px;
    }
    button.single-join {
      background: #103f5e;
      width: 112px;
      height: 32px;
      border: none;
      color: #ffffff;
      border-radius: 16px;
      margin: auto;
      font-weight: 400;
      display: flex;
      align-items: 16px;
      font-size: 16px;
      justify-content: center;
      align-items: center;
      line-height: 19px;
      margin-inline-end: 16px;
    }
    button.single-dismiss {
      background: #ffffff;
      width: 112px;
      height: 32px;
      border: solid #f46a6a 1px;
      color: #f46a6a;
      border-radius: 16px;
      margin: auto;
      font-weight: 400;
      display: flex;
      align-items: 16px;
      font-size: 16px;
      justify-content: center;
      align-items: center;
      line-height: 19px;
      margin-inline-start: 16px;
    }
    .inside-emergency-line {
      width: 420px;
      height: 1px;
      background: #ebebeb;
      margin: 0px auto 20px auto;
    }
    svg {
      margin-top: 21px;
      margin-inline-end: 21px;
      margin-bottom: 0px;
      margin-inline-start: 0px;
    }
    .hint-modal {
      font-weight: 400;
      font-size: 16px;
      line-height: 26px;
      text-align: center;
      color: #4a4a4a;
      width: 420px;
      margin: 0px auto 40px auto;

      .sessionName {
        font-weight: 700;
      }
    }
  }
}
</style>
